import { render, staticRenderFns } from "./JcomGnotePreview.vue?vue&type=template&id=398d880e"
import script from "./JcomGnotePreview.vue?vue&type=script&lang=js"
export * from "./JcomGnotePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports